import { createEvent, createStore } from 'effector';
import { IGameRequest } from '@interfaces/IGameRequest';

export const addSelectedGames = createEvent<IGameRequest[]>();
export const clearSelectedGames = createEvent();
const selectedGames = createStore<IGameRequest[]>([])
  .on(addSelectedGames, (state, games) => {
    return games;
  })
  .reset(clearSelectedGames);

export default selectedGames;
